import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './styles/about.module.css';

const About = () => {

  return (
     <div className={styles.about_page}>
      <div className={styles.about_content}>
        <Outlet />
      </div>
    </div>
  );
};
export default About;